import _functionBindNative from "../internals/function-bind-native";
var exports = {};
var NATIVE_BIND = _functionBindNative;
var call = Function.prototype.call;
exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};
export default exports;